import styled from 'styled-components'

export const Layout = styled.div`
  cursor: pointer;
  margin: 0 0.875rem 0 0;
`
export const Caption = styled.div`
  color: ${props => props.theme.STATS_GREY_COLOR};
`
